import { lazy } from 'react';

export const SupportFaq = lazy(() => import('./Faq.component'));
